import { insertIcon } from '@components/Icon/Icon';

export const articleTextIcon = () => {
  const articleText = document.querySelector('.bo-article-text');
  if (!articleText) return;

  const paywallBanner = document.querySelector('.js-paywall-banner');
  if (paywallBanner) return;

  // Start with the last <p> tag and traverse backwards
  let lastP = articleText.querySelector(':scope > p:last-of-type');

  while (
    lastP &&
    (lastP.tagName !== 'P' || lastP.classList.contains('embed-block'))
  ) {
    lastP = lastP.previousElementSibling;
  }

  const logoElement = document.createElement('span');
  logoElement.style.display = 'inline-flex';
  logoElement.id = 'freitag-article-end'; // used by matomo

  lastP?.insertAdjacentElement('beforeend', logoElement);

  insertIcon(
    { iconName: 'logof', width: 12, height: 12, isImg: false },
    logoElement,
  );
};
